var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56857 12.968H15.35V1.621C15.35 0.727018 14.5851 0 13.6444 0L2.55833 0C1.52988 0 0 0.647589 0 2.4315L0 13.7785C0 15.5624 1.52988 16.21 2.55833 16.21H15.35L15.35 14.589H2.56857C2.17458 14.5793 1.70556 14.4318 1.70556 13.7785C1.70556 13.6966 1.71323 13.6237 1.72602 13.5572C1.82153 13.0904 2.22404 12.9761 2.56857 12.968V12.968ZM4.81649 4.57284C5.17144 4.23978 5.65016 4.05302 6.14895 4.05302C6.64775 4.05302 7.12647 4.23978 7.48142 4.57284L7.67244 4.75034L7.86261 4.57284C8.21771 4.23973 8.69657 4.05295 9.1955 4.05295C9.69444 4.05295 10.1733 4.23973 10.5284 4.57284C10.7045 4.73384 10.8447 4.92699 10.9404 5.1407C11.0361 5.35441 11.0854 5.58429 11.0854 5.81655C11.0854 6.04882 11.0361 6.2787 10.9404 6.49241C10.8447 6.70612 10.7045 6.89926 10.5284 7.06027L7.67329 9.726L4.81734 7.06027C4.64104 6.89938 4.50075 6.70629 4.40489 6.49261C4.30903 6.27892 4.25957 6.04903 4.25949 5.81673C4.25941 5.58443 4.30871 5.3545 4.40442 5.14076C4.50014 4.92701 4.64029 4.73384 4.81649 4.57284V4.57284Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle1.e2404e947ba605b995a6c9f7a19b6126.svg";
export { ForwardRef as ReactComponent };